import { SELECT_LOT_FOR_EDIT, ERASE_LOT, UPDATE_LOT_STORE } from '../../actions/types';
import { ConvertToBool } from '../../../components/Utils/GenericFunctions';
const initialState = {};


export default (state = initialState, action) => {

  switch (action.type) {

    case SELECT_LOT_FOR_EDIT:
      return Object.assign({}, state, {
        ...action.payload
      });

    case UPDATE_LOT_STORE:
      const newObj = JSON.parse(JSON.stringify(state));
      if (action.payload.propName === 'WithA1')
        action.payload.propValue = ConvertToBool(action.payload.propValue);
      if (action.payload.propName === 'AmountDebited')
        action.payload.propValue = ConvertToBool(action.payload.propValue);
      newObj[action.payload.propName] = action.payload.propValue

      return Object.assign({}, state,
        newObj
      );

    case ERASE_LOT:
      return Object.assign({}, {}
      );
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/negotiationLot/negotiationLotReducer.js